import { useQuery } from '@tanstack/react-query';
import type { PageMetaResponse } from '../api/pageApi';
import { PageApi } from '../api/pageApi';

const fetchPageMeta = async (path: string): Promise<PageMetaResponse> => {
  const res = await fetch(`${PageApi.BASE_URL}/page/meta?path=${encodeURIComponent(path)}`);
  if (!res.ok) {
    throw new Error(await res.text());
  }
  return res.json();
};

export const usePageMeta = (path: string, options?: { enabled?: boolean }) => {
  return useQuery<PageMetaResponse>({
    queryKey: ['pageMeta', path],
    queryFn: () => fetchPageMeta(path),
    enabled: options?.enabled !== undefined ? options.enabled : true,
  });
};
